// istanbul ignore file
// TODO: Add tests as part of DMD-4932
import { useFormContext } from 'react-hook-form';

import { useAccessToken } from 'reservations/account/providers/AccessTokenProvider';
import BaseButton from 'reservations/base/components/BaseButton';
import { useLoadingSpinner } from 'reservations/base/providers/LoadingSpinnerProvider';
import { useCustomRouter } from 'reservations/base/providers/RouterProvider';
import type { HandleErrorOptions } from 'reservations/booking/types';
import { updateMarketingConsent } from 'reservations/form/queries/updateMarketingConsent';
import {
  type CreateWaitlistSuccessOptions,
  useCreateWaitlistMutation
} from 'reservations/waitlist/queries/useCreateWaitlistMutation';

type AddToWaitlistButtonProps = {
  handleFormDrawerClose: () => void;
};

function AddToWaitlistButton({
  handleFormDrawerClose
}: AddToWaitlistButtonProps) {
  const { handleHasLoaded, handleIsLoading } = useLoadingSpinner();
  const { handleSubmit } = useFormContext();
  const { handleNavigation } = useCustomRouter();
  const { access_token: apiKey, slug } = useAccessToken();

  // istanbul ignore next
  const handleSuccess = ({
    navUrl,
    waitlist
  }: CreateWaitlistSuccessOptions) => {
    updateMarketingConsent(waitlist);
    handleFormDrawerClose();
    handleHasLoaded();

    if (navUrl != null) {
      handleNavigation(navUrl);
    }
  };

  // istanbul ignore next
  const handleError = ({ navUrl, forceReload }: HandleErrorOptions) => {
    handleHasLoaded();

    if (navUrl || forceReload) {
      handleNavigation(navUrl, forceReload);
    }
  };

  const mutation = useCreateWaitlistMutation({
    apiKey,
    slug,
    handleSuccess,
    handleError
  });

  const onSubmit = (data: Record<string, any>) => {
    handleIsLoading('Adding your party to the waitlist...');
    mutation.mutate(data);
  };

  return <BaseButton label="Confirm" onClick={handleSubmit(onSubmit)} />;
}

export default AddToWaitlistButton;
